import React from 'react';
import WaitlistForm from './WaitlistForm';

export default function LandingPage() {
  return (
    <main className="landing-shell">
      <section className="landing-hero">
        <div className="landing-grid">
          <div className="space-y-5">
            <p className="eyebrow">CrypnAI</p>
            <h1 className="landing-title">
              Crypto analysis built from data first.
            </h1>
            <p className="landing-subtitle">
              CrypnAI starts with market data and technical calculations, then uses model debate to turn that context into a clear trade plan with defined risk.
            </p>
            <div className="hero-actions">
              <a href="/login" className="btn-primary">Open dashboard</a>
              <a href="#waitlist" className="btn-secondary">Join waitlist</a>
            </div>
            <div className="pill-row">
              <span className="soft-pill">Real-time Hyperliquid data</span>
              <span className="soft-pill">OpenRouter multi-model stack</span>
              <span className="soft-pill">5m · 15m · 1h · 4h · 1d</span>
            </div>
          </div>

          <div className="hero-card glass-panel-strong">
            <h3>How it works</h3>
            <ul>
              <li><strong>Engine:</strong> Backend code calculates indicators and market context before the models weigh in</li>
              <li><strong>Analysis:</strong> Multiple models review each timeframe, then one final consensus output is generated</li>
              <li><strong>Focus:</strong> Faster decisions, clearer risk, less prompt noise</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="landing-section-wrap">
        <div className="landing-section-grid">
          <article className="landing-feature-card glass-panel">
            <h3>1. Data comes first</h3>
            <p>
              Technical indicators and market metrics are computed in backend code before AI sees the market, so the models work from the same numbers.
            </p>
          </article>
          <article className="landing-feature-card glass-panel">
            <h3>2. Multi-model review</h3>
            <p>
              Each timeframe is reviewed independently, then a synthesis step resolves disagreement into one final call.
            </p>
          </article>
          <article className="landing-feature-card glass-panel">
            <h3>3. Output you can use</h3>
            <p>
              Each timeframe returns trend, confidence, key levels, risks, invalidation points, and a trade stance: LONG, SHORT, or WAIT.
            </p>
          </article>
        </div>
      </section>

      <section id="waitlist" className="landing-waitlist glass-panel-strong">
        <div>
          <p className="eyebrow">Early Access</p>
          <h2>Get early access to CrypnAI</h2>
          <p>
            Join the waitlist for product updates, feature releases, and early onboarding.
          </p>
        </div>
        <WaitlistForm />
        <p className="landing-disclaimer">
          Not financial advice. Trading carries risk. Use your own judgment and risk controls.
        </p>
      </section>

      <footer className="landing-footer">
        <p>© 2026 CrypnAI. All rights reserved.</p>
      </footer>
    </main>
  );
}
